import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetSessionSummaryResponse } from '@arc/unified-payments-frontend/shared-payment';
import {
  PayOnAccountCoreComponentActions,
  SessionState,
  SessionStore,
} from '@arc/unified-payments-frontend/shared-stores';
import { Store } from '@ngrx/store';
import { filter, map, Observable } from 'rxjs';

@Component({
  selector: 'payment-pay-on-account-core',
  templateUrl: './pay-on-account-core.component.html',
  styleUrls: ['./pay-on-account-core.component.scss'],
})
export class PayOnAccountCoreComponent implements OnInit {
  constructor(
    private store: Store,
    private sessionStore: Store<SessionState>,
    private route: ActivatedRoute,
  ) {}

  sessionSummary$: Observable<GetSessionSummaryResponse>;

  ngOnInit(): void {
    this.sessionSummary$ = this.sessionStore.select(SessionStore);
    const sessionId = this.route.snapshot.paramMap.get('sessionId');

    this.sessionSummary$
      .pipe(filter((sessionSummary) => sessionSummary == null))
      .subscribe(() => {
        this.store.dispatch(
          PayOnAccountCoreComponentActions.initializePayOnAccountCoreAction({
            sessionId,
          }),
        );
      });
  }
}
